import { render } from "./BudgetByEntityChart.vue?vue&type=template&id=264f54cf"
import script from "./BudgetByEntityChart.vue?vue&type=script&lang=js"
export * from "./BudgetByEntityChart.vue?vue&type=script&lang=js"
script.render = render

export default script